/**
 * Product Card Variant Click Handler
 *
 * Detecta cliques em swatches de cor e pills de tamanho nos product cards
 * e abre o quick-add modal com a variante pré-selecionada.
 *
 * @class ProductCardVariantClick
 */

class ProductCardVariantClick {
  constructor() {
    this.init();
  }

  init() {
    // Event delegation no document para performance
    document.addEventListener('click', (e) => {
      // Verifica se clicou em label dentro de .product-parameters em product cards
      const label = e.target.closest('.card-wrapper .product-parameters label');
      if (!label) return;

      // Previne comportamento padrão e propagação
      e.preventDefault();
      e.stopPropagation();

      this.handleVariantClick(label);
    });
  }

  /**
   * Handle click em swatch/pill de variante
   *
   * @param {HTMLElement} label - O label clicado
   */
  handleVariantClick(label) {
    const card = label.closest('.card-wrapper');
    if (!card) return;

    // Pegar o input associado ao label
    const input = document.getElementById(label.getAttribute('for'));
    if (!input) return;

    // Extrair informação da variante
    const optionName = input.name.split('-')[0]; // Ex: "Color", "Size", "Cor", "Tamanho"
    const optionValue = input.value;

    // Encontrar o modal opener do card
    const modalOpener = card.querySelector('modal-opener[data-modal^="#QuickAdd"]');
    if (!modalOpener) {
      console.warn('[ProductCardVariantClick] Modal opener not found in card');
      return;
    }

    // Adicionar informação de pré-seleção baseado no tipo de opção
    const optionNameLower = optionName.toLowerCase();

    if (optionNameLower.includes('color') || optionNameLower.includes('cor')) {
      modalOpener.dataset.preselectedColor = optionValue;
    } else if (optionNameLower.includes('size') || optionNameLower.includes('tamanho')) {
      modalOpener.dataset.preselectedSize = optionValue;
    } else {
      // Para outras opções, usar nome genérico
      modalOpener.dataset.preselectedOption = optionValue;
    }

    // Abrir o modal
    const button = modalOpener.querySelector('button');
    if (button) {
      button.click();
    } else {
      console.warn('[ProductCardVariantClick] Button not found in modal opener');
    }
  }
}

// Inicializar quando DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCardVariantClick();
  });
} else {
  // DOM já está pronto, inicializar imediatamente
  new ProductCardVariantClick();
}
